// src/authConfig.js
import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: '829e941f-bd02-4bc8-ab8c-d2adffee4872', // Your Azure app's client ID
    authority: 'https://login.microsoftonline.com/f01aeb10-788c-4137-b031-9eb6bcccd671', // Azure Tenant ID or common if multi-tenant
    redirectUri: 'https://oil.spm-automation.com/login-callback', // The URI to redirect to after login
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your tokens are stored
    storeAuthStateInCookie: false, // Set to true for IE11 or Edge compatibility
  },
};

// Initialize an MSAL instance with the configuration
export const msalInstance = new PublicClientApplication(msalConfig);
